module.exports = require("node-hid");